/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./project-demo-add-dialog.vue?vue&type=template&id=6ef82f72&"
import script from "./project-demo-add-dialog.vue?vue&type=script&lang=ts&"
export * from "./project-demo-add-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports